module.exports = __webpack_public_path__ + "img/傑出系友.377e549a.webp";